// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3_Lo2","selects":"Documents_selects__3hUMk"};